import headerLogo from "../assets/images/Header/logo.png";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

/** Default cover when a post has no uploaded cover image. */
export const BLOG_COVER_FALLBACK_SRC = headerLogo;

/**
 * Resolve a stored blog image path to a browser-loadable URL.
 * Only supports server uploads under /uploads/blog-images/ (or absolute http URLs).
 * @param {string | null | undefined} imagePath
 * @returns {string | null}
 */
export function resolveBlogImageSrc(imagePath) {
    if (!imagePath || typeof imagePath !== "string") return null;

    const raw = imagePath.trim();
    if (!raw) return null;

    if (/^https?:\/\//i.test(raw)) return raw;

    if (!raw.startsWith("/uploads/blog-images/")) return null;

    const base = String(API_BASE_URL).replace(/\/$/, "");
    return base ? `${base}${raw}` : raw;
}

/**
 * @param {string | null | undefined} imagePath
 * @returns {boolean}
 */
export function isUploadedBlogImagePath(imagePath) {
    return typeof imagePath === "string" && imagePath.trim().startsWith("/uploads/blog-images/");
}

/**
 * Cover image URL for list/detail views — falls back to site logo when missing.
 * @param {string | null | undefined} imagePath
 * @returns {string}
 */
export function resolveBlogCoverSrc(imagePath) {
    return resolveBlogImageSrc(imagePath) || BLOG_COVER_FALLBACK_SRC;
}

/**
 * @param {string | null | undefined} imagePath
 * @returns {boolean}
 */
export function isBlogCoverFallback(imagePath) {
    return !resolveBlogImageSrc(imagePath);
}
